import { AddMedicalHistory as AddMedicalHistoryForm } from '../components/AddMedicalHistory'

export function AddMedicalHistory() {
  return (
    <div>
      <div className="max-w-4xl mx-auto">
        <AddMedicalHistoryForm />
      </div>
    </div>
  )
} 